<template>
    <svg height="24px" width="24px" focusable="false" viewBox="0 0 24 24" fill="currentColor" class="a-s-fa-Ha-pa">
        <g>
            <path
                d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z">
            </path>
            <path d="M0 0h24v24H0z" fill="none"></path>
        </g>
    </svg>
</template>
<script>
export default {
    name: 'FolderSharedSvg',
}
</script>



